export const USP_DEFAULT_CARDS = [
  {
    headline: 'SHARED.USP.EQUIPMENT.HEADLINE',
    subline: 'SHARED.USP.EQUIPMENT.SUBLINE',
    mobileImage: '/images/icons/usp-equipment-small.svg',
    image: '/images/icons/usp-equipment-large.svg',
  },
  {
    headline: 'SHARED.USP.DISCOUNT.HEADLINE',
    subline: 'SHARED.USP.DISCOUNT.SUBLINE',
    mobileImage: '/images/icons/usp-discount-small.svg',
    image: '/images/icons/usp-discount-large.svg',
  },
  {
    headline: 'SHARED.USP.DELIVERY.HEADLINE',
    subline: 'SHARED.USP.DELIVERY.SUBLINE',
    mobileImage: '/images/icons/usp-delivery-small.svg',
    image: '/images/icons/usp-delivery-large.svg',
  },
];

export const USP_IT_DISCLAIMER_LINK = 'http://support-it.metro-marketplace.eu/it/support/solutions/folders/75000013693';
